export default {
  ArTypeCode: "",
  Description: "",
  UserModified: localStorage.getItem("UserName"),
};
